export const SENTRY_MIN_THRESHOLD = 10;
export const SENTRY_MEDIUM_THRESHOLD = 30;
export const SENTRY_MAX_THRESHOLD = 60;

export const MS_TO_SEC = 1000;

export const SLOW = 'Slow';
export const VERY_SLOW = 'Very Slow';
export const EXTREMELY_SLOW = 'Extremely Slow';
